import type { Undef } from 'types/UtilityTypes';

import type { SharepointWorkbookRowsResponse } from '../types/SharepointWorkbookRows';

/**
 * Stable key for a Graph load-suggestions payload. Used to skip redundant
 * state updates when polling returns unchanged suggestions.
 */
export function sharepointWorkbookRowsResponseSignature(
  documentUrl: string,
  worksheetQueryParam: Undef<string>,
  data: SharepointWorkbookRowsResponse
): string {
  return [
    documentUrl.trim(),
    worksheetQueryParam?.trim() ?? '',
    String(data.contractVersion),
    data.templateId,
    data.fileName,
    data.worksheetName,
    String(data.rowCount),
    String(data.columnCount),
    JSON.stringify(data.suggestions),
  ].join('\x1f');
}
